import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  basketDrawer: false,
  DelAddError: true,
  BillAddError: true,
  BillAddSame: false,
  PSToken: '',
  paymentMessage: '',
  canvasView: 'clean',
  filter: {
    shape: 'All',
    colour: 'All',
    category: 'All',
    sort: 'Default',
  },
};

const siteCompSlice = createSlice({
  name: 'siteComp',
  initialState,
  reducers: {
    setStateValue: (state, action) => {
      const { key, value } = action.payload;
      const keys = key.split('.');
      let nestedState = state;
      keys.slice(0, -1).forEach((k) => {
        nestedState = nestedState[k];
      });
      nestedState[keys[keys.length - 1]] = value;
    },
    resetStateValue: (state, action) => {
      const { key, defaultValue } = action.payload;
      const keys = key.split('.');
      let nestedState = state;
      keys.slice(0, -1).forEach((k) => {
        nestedState = nestedState[k];
      });
      nestedState[keys[keys.length - 1]] = defaultValue;
    },
  },
});

export const { setStateValue, resetStateValue } = siteCompSlice.actions;

export default siteCompSlice.reducer;
